module.exports = __webpack_public_path__ + "img/nbc.0001726f.svg";